import React from 'react';
import {useEffect} from 'react';
import {Platform} from 'react-native';

// Only web used
export const useOnClickOutside = (
  ref: React.RefObject<any>,
  handler: (e: MouseEvent | TouchEvent) => void,
  options?: boolean | AddEventListenerOptions,
) => {
  if (Platform.OS === 'web') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(
      () => {
        const listener = (event: MouseEvent | TouchEvent) => {
          // Do nothing if clicking ref's element or descendent elements
          if (!ref.current || ref.current.contains(event.target)) {
            return;
          }

          // Hack for working with mui popover
          const popoverRoot = document.querySelector('.MuiPopover-root');
          if (popoverRoot && popoverRoot.contains(event.target as Node)) {
            return;
          }

          // Hack for correct working to notification click if modal is open
          const notificationRoot = document.querySelector('#notification_blank');
          if (notificationRoot && notificationRoot.contains(event.target as Node)) {
            return;
          }

          handler(event);
        };

        document.addEventListener('mousedown', listener, options);
        document.addEventListener('touchstart', listener, options);

        return () => {
          document.removeEventListener('mousedown', listener, options);
          document.removeEventListener('touchstart', listener, options);
        };
      },
      // Add ref and handler to effect dependencies
      // It's worth noting that because passed in handler is a new ...
      // ... function on every render that will cause this effect ...
      // ... callback/cleanup to run every render. It's not a big deal ...
      // ... but to optimize you can wrap handler in useCallback before ...
      // ... passing it into this hook.
      [ref, handler],
    );
  }
};
